var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    style: {
      position: "relative"
    }
  }, /*#__PURE__*/React.createElement("svg", _extends({
    id: "langify-icon-bg",
    width: 75,
    height: 90,
    viewBox: "0 0 75 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "scale(0.175 -0.175) translate(50 -500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 209.996,50.0039 H 90 V 170.004 C 90,236.168 143.832,290 209.996,290 c 66.168,0 120,-53.832 120,-119.996 0,-66.168 -53.832,-120.0001 -120,-120.0001 z m 0,289.9961 C 116.258,340 40,263.742 40,170.004 V 40.0039 L 0,0.00390625 h 209.996 c 93.742,0 170,76.25779375 170,170.00009375 0,93.738 -76.258,169.996 -170,169.996"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "langify-icon",
    width: 75,
    height: 90,
    viewBox: "0 0 75 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "scale(0.175 -0.175) translate(50 -500)"
  }, /*#__PURE__*/React.createElement("path", {
    "stroke-alignment": "inner",
    d: "M 209.996,50.0039 H 90 V 170.004 C 90,236.168 143.832,290 209.996,290 c 66.168,0 120,-53.832 120,-119.996 0,-66.168 -53.832,-120.0001 -120,-120.0001 z m 0,289.9961 C 116.258,340 40,263.742 40,170.004 V 40.0039 L 0,0.00390625 h 209.996 c 93.742,0 170,76.25779375 170,170.00009375 0,93.738 -76.258,169.996 -170,169.996"
  })))), /*#__PURE__*/React.createElement("svg", _extends({
    id: "langify-icon-cover",
    width: 75,
    height: 90,
    viewBox: "0 0 75 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "scale(0.175 -0.175) translate(50 -500)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 209.996,50.0039 H 90 V 170.004 C 90,236.168 143.832,290 209.996,290 c 66.168,0 120,-53.832 120,-119.996 0,-66.168 -53.832,-120.0001 -120,-120.0001 z m 0,289.9961 C 116.258,340 40,263.742 40,170.004 V 40.0039 L 0,0.00390625 h 209.996 c 93.742,0 170,76.25779375 170,170.00009375 0,93.738 -76.258,169.996 -170,169.996"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.0a921298a9eb408f4b63c1b41c1f1919.svg";
export { ForwardRef as ReactComponent };